import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';



import { ButtonThemeComponent } from '../ui/button-theme/button-theme.component';
// import { CryptoService } from '@app/shared/crypto/crypto.service';
import { BtnBackComponent } from '../ui/btn-back/btn-back.component';
import { FooterComponent } from '../ui/footer/footer.component';
import { MatTableModule } from '@angular/material/table';

import { MatSortModule } from '@angular/material/sort';
import { HeaderComponent } from '@app/ui/header/header.component';
import { UserProfileComponent } from '@app/ui/user-profile/user-profile.component';
import { UserMenuComponent } from '@app/ui/user-menu/user-menu.component';
import { SubHeaderComponent } from '../ui/sub-header/sub-header.component';
import { MatRippleModule } from '@angular/material/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatGridListModule } from '@angular/material/grid-list';
import { ScrollDispatchModule } from '@angular/cdk/scrolling';
import { A11yModule } from '@angular/cdk/a11y';

import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LottieAnimationViewModule } from 'ng-lottie';


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		MatToolbarModule,
		MatSelectModule,
		MatTabsModule,
		MatInputModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatChipsModule,
		MatCardModule,
		MatSidenavModule,
		MatCheckboxModule,
		MatListModule,
		MatMenuModule,
		MatIconModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatDialogModule,
		MatSliderModule,
		MatExpansionModule,
		MatStepperModule,
		MatBadgeModule,
		MatSlideToggleModule,
		MatBottomSheetModule,
		MatRadioModule,
		MatTableModule,
		MatSortModule,
		MatRippleModule,
		FlexLayoutModule,
		MatStepperModule,
		ScrollDispatchModule,
		A11yModule,
		LazyLoadImageModule,
		LottieAnimationViewModule.forRoot()
	],
	declarations: [
		FooterComponent,
		ButtonThemeComponent,
		BtnBackComponent,
		HeaderComponent,
		UserProfileComponent,
		UserMenuComponent,
		SubHeaderComponent,

	],
	exports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		MatMenuModule,
		MatTabsModule,
		MatChipsModule,
		MatInputModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatCheckboxModule,
		MatCardModule,
		MatSidenavModule,
		MatListModule,
		MatSelectModule,
		MatToolbarModule,
		MatIconModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatDialogModule,
		MatSliderModule,
		MatExpansionModule,
		MatStepperModule,
		MatBadgeModule,
		FooterComponent,
		MatSlideToggleModule,
		ButtonThemeComponent,
		MatBottomSheetModule,
		MatRadioModule,
		BtnBackComponent,
		MatTableModule,
		MatSortModule,
		HeaderComponent,
		UserProfileComponent,
		UserMenuComponent,
		SubHeaderComponent,
		MatRippleModule,
		ScrollDispatchModule,
		MatGridListModule,
		A11yModule,
		LazyLoadImageModule,
		LottieAnimationViewModule
	],
	providers: [
		// CryptoService
	],
})
export class SharedModule { }
